import { t } from "i18next";

export function checkIfModeOfSaleExist(
    formState: any,
    modeSaleData: any,
    dataArchive: any
) {
    if (!modeSaleData?.data || !dataArchive) return false;

    const allData = [...modeSaleData.data, ...dataArchive];
    return allData.some((el: any) => el["Mode of sale"] === formState.saleMode);
}

export function checkIfModeOfSaleFranchiseExist(
    formState: any,
    modeOfSaleFranchise: any
) {
    const franchiseList = modeOfSaleFranchise?.othersData?.modeOfSaleFranchise;
    if (!franchiseList) return false;

    return franchiseList.some(
        (el: any) => el["Mode of sale"] === formState.saleMode
    );
}

export function checkIfModeOfSaleFranchiseExistAndArchived(
    formState: any,
    dataFranchiseArchive: any
) {
    if (!dataFranchiseArchive) return false;

    return dataFranchiseArchive.some(
        (el: any) => el["Mode of sale"] === formState.saleMode
    );
}

export function associateModeOfSale(dataSale: any, shopsModeSaleData: any) {
    const idsAssociated: Set<any> = new Set();
    const associated: any[] = [];

    if (shopsModeSaleData?.data) {
        shopsModeSaleData.data.forEach((element: any) => {
            element?.subRows?.forEach((el: any) => {
                if (el.Id === dataSale.Id) {
                    idsAssociated.add(el.shopId);
                    associated.push(el);
                }
            });

            element?.archivedModeOfSales?.forEach((el: any) => {
                if (el.Id === dataSale.Id) {
                    idsAssociated.add(el.shopId);
                    associated.push(el);
                }
            });
        });
    }

    return associated;
}

export function isInclude(element: any, array: any[]) {
    return array.includes(element);
}
export function updateSalesSupportData(
    saleMode: any,
    modeSaleData: any,
    dataSale: any,
    salesSupport: any,
    setState: any,
    SalesModesTypesAndTag: any
) {
    let isDeliverooUsed = false;
    let isSaleModeEditable = false;

    const combinedSalesData = [
        ...modeSaleData.data,
        ...modeSaleData.othersData.dataArchive,
    ];

    isDeliverooUsed = combinedSalesData.some((entry) =>
        entry.support_vente.includes(DELIVEROO)
    );

    if (dataSale.Id !== undefined) {
        isSaleModeEditable =
            !salesSupport.includes(DELIVEROO) &&
            dataSale.support_vente.includes(DELIVEROO);
    }

    const saleSupportList = SalesModesTypesAndTag.ListSaleSupport;

    if (saleMode !== "") {
        const allowedModes = [t(TAKEAWAY_EN), t(IN_DELIVERY_EN)];

        if (
            (!isDeliverooUsed || isSaleModeEditable) &&
            allowedModes.includes(saleMode)
        ) {
            setState((prev: any) => ({
                ...prev,
                salesSupportData: saleSupportList,
            }));
        } else {
            const filteredData = saleSupportList.filter(
                (element: string) => element !== DELIVEROO
            );
            setState((prev: any) => ({
                ...prev,
                salesSupportData: filteredData,
            }));
        }
    }
}
export function checkDeliverooAvailability({
    oneShop,
    modeSaleData,
    modeOfSaleFranchise,
    formState,
}: any) {
    let isDeliverooAvaible = {
        active: false,
        saleMode: "",
    };

    if (oneShop) {
        const combinedSalesDataShop = [
            ...modeSaleData.data,
            ...modeSaleData.othersData.dataArchive,
        ];

        const isDeliverooUsed = combinedSalesDataShop.some((entry) =>
            entry.support_vente.includes("Deliveroo")
        );

        const combinedSalesData = [
            ...modeOfSaleFranchise.othersData.dataOfFranchiseArchive,
            ...modeOfSaleFranchise.othersData.modeOfSaleFranchise,
        ];

        const deliverooEntry = combinedSalesData.find((entry) =>
            entry.support_vente.includes("Deliveroo")
        );

        const isDeliveroUsedInFranchiseWithAnySaleMode = {
            saleMode: deliverooEntry ? deliverooEntry["Mode of sale"] : "",
            isDeliverooUsed: deliverooEntry !== undefined,
        };

        isDeliverooAvaible = {
            active:
                isDeliveroUsedInFranchiseWithAnySaleMode &&
                formState.saleMode !== undefined &&
                isDeliveroUsedInFranchiseWithAnySaleMode.isDeliverooUsed &&
                formState.saleMode !==
                    isDeliveroUsedInFranchiseWithAnySaleMode.saleMode &&
                !isDeliverooUsed,
            saleMode: isDeliveroUsedInFranchiseWithAnySaleMode.saleMode,
        };
    }

    return isDeliverooAvaible;
}

export function updateNumberActiveAndArchive(
    dataTable: any,
    setNumberActive: (value: number) => void,
    setNumberArchived: (value: number) => void
) {
    const hasData = dataTable?.othersData;
    if (hasData && hasData.numberActive !== undefined) {
        setNumberActive(hasData.numberActive);
        setNumberArchived(hasData.numberArchive);
    } else {
        setNumberActive(0);
        setNumberArchived(0);
    }
}

export function associateModeOfSaleCustomIcons(
    shopsModeSaleData: any,
    selectedRow: any
): any[] {
    const idsAssociated: any[] = [];

    if (shopsModeSaleData?.data) {
        shopsModeSaleData.data.forEach((element: any) => {
            element.subRows?.forEach((elt: any) => {
                if (elt.Id === selectedRow.Id) {
                    idsAssociated.push(elt);
                }
            });
        });
    }

    return idsAssociated;
}

export function archiveModeSale(shopsModeSaleData: any): any[] {
    let idsAssociated: any[] = [];

    if (shopsModeSaleData?.data) {
        shopsModeSaleData.data.forEach((element: any) => {
            element.subRows?.forEach((el: any) => {
                idsAssociated.push(el.Id);
            });
        });
    }

    return [...new Set(idsAssociated)];
}

export function archiveModeOfSaleFranchise(
    archivedModeOfSaleFranchise: any
): any[] {
    let idsAssociated: any[] = [];

    const franchiseData =
        archivedModeOfSaleFranchise?.othersData?.archivedModeOfSaleFranchise;

    if (franchiseData) {
        franchiseData.forEach((element: any) => {
            idsAssociated.push(element.Id);
        });
    }

    return [...new Set(idsAssociated)];
}

// utils/getModeOfSalePayload.ts

type ModeSalePayloadParams = {
    type: "activate" | "favorite" | "unfavorite";
    selectedRow: any;
    userID: any;
    franchiseID: string;
    operatorID: string;
    uuidUser: any;
    modeSaleData?: any; // only needed for "favorite"
};

export function getModeOfSalePayload({
    type,
    selectedRow,
    userID,
    franchiseID,
    operatorID,
    uuidUser,
    modeSaleData,
}: ModeSalePayloadParams) {
    const base = {
        userId: userID,
        shopId: [selectedRow.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser,
        isEmpty: false,
    };

    if (type === "activate") {
        return [
            {
                ...base,
                isShop: false,
                data: {
                    [selectedRow.Id]: {
                        designation: selectedRow["Mode of sale"],
                        tag: selectedRow.tag,
                        display_name: selectedRow.display_name,
                        support_vente: selectedRow.support_vente,
                        isArchived: false,
                        isFavorite: selectedRow.isFavorite,
                        state:
                            selectedRow.shopId === "0"
                                ? true
                                : selectedRow.state,
                        shopId: selectedRow.shopId,
                        advancedDisplayName: selectedRow.advancedDisplayName,
                    },
                },
            },
        ];
    }

    if (type === "unfavorite") {
        return [
            {
                ...base,
                isShop: false,
                data: {
                    [selectedRow.Id]: {
                        designation: selectedRow["Mode of sale"],
                        tag: selectedRow.tag,
                        display_name: selectedRow.display_name,
                        support_vente: selectedRow.support_vente,
                        isArchived: selectedRow.isArchived,
                        isFavorite: false,
                        state: selectedRow.state,
                        shopId: selectedRow.shopId,
                        advancedDisplayName: selectedRow.advancedDisplayName,
                    },
                },
            },
        ];
    }

    if (type === "favorite" && modeSaleData) {
        const data = modeSaleData.data.reduce((updated: any, mode: any) => {
            if (mode.Id === selectedRow.Id || mode.isFavorite === true) {
                updated[mode.Id] = {
                    designation: mode["Mode of sale"],
                    tag: mode.tag,
                    display_name: mode.display_name,
                    support_vente: mode.support_vente,
                    isArchived: mode.isArchived,
                    state: mode.state,
                    shopId: mode.shopId,
                    isFavorite: mode.Id === selectedRow.Id,
                    advancedDisplayName: mode.advancedDisplayName,
                };
            }
            return updated;
        }, {});

        return [
            {
                ...base,
                isFavoring: true,
                data,
            },
        ];
    }

    return [];
}

export type ModeOfSaleFormType = {
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    dataSale: React.SetStateAction<any>;
    setDataSale: Function;
    setLocalFilterActive: Function;
    inputSaleMode: boolean;
    setInputSaleMode: Function;
    setSelectSales: Function;
    selectSales: boolean;
    selectName: boolean;
    setSelectName: Function;
    setLimit: Function;
    isConsult: boolean;
    setIsConsult: Function;
    dataState: any;
    SalesModesTypesAndTag: any;
    formState: any;
    setFormState: Function;
    setSalesSupport: Function;
    salesSupport: any;
    setTagsData: Function;
    tagsData: any;
    setModalState: Function;
    modalState: any;
    isLoading: any;
};

export type SubmitModeOfSaleProps = {
    mode: "add" | "edit";
};

export const INITIAL_SALE_MODE_FORM_STATE = {
    title: t("Add a sales method"),
    saleMode: "",
    tag: "",
    tagsData: [],
    displayName: "",
    advancedDisplayName: {
        languages: {
            fr: "",
            en: "",
            nl: "",
            es: "",
            pt: "",
            it: "",
        },
    },
    isNameExist: false,
    selectName: false,
    inputSaleMode: false,
    selectSales: false,
};

export const initialUIState = {
    isAddModeOfSaleClicked: false,
    isInInitializationModalOpened: false,
    isHistoryModalOpened: false,
    isModalOpened: false,
    isFavoriteModified: false,
    isAddNewModeOfSaleButtonClicked: false,
};
export const initialState = {
    salesSupportData: [],
    language: [],
    saleSupportUsed: [],
    salesMode: [],
    tags: [],
    associated: [],
};

export const MODE_OF_SALE_LABEL = "Mode of sale";
export const DELIVEROO = "Deliveroo";
export const TAKEAWAY_EN = "Takeaway";
export const IN_DELIVERY_EN = "In delivery";

export async function FetchPost(
    payload: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`;

        const data = await fetchGlobal<any>(apiUrlAdd, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        return data;
    } catch (error) {
        console.error("❌ Erreur lors de l'appel API :", error);
        throw error;
    }
}

export const getSaleSupportUsed = async (
    userID: any,
    shopId: any,
    franchiseID: any,
    dataSaleId: any,
    setState: any,
    setIsModeOfSaleActiveInTemplate: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) => {
    try {
        const [supportRes, consumedRes] = await Promise.all([
            fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/isModeOfSaleUsed?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&modeOfSale=${dataSaleId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ),
            fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=salesMethods`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ),
        ]);

        const localSaleSupportUsed = supportRes.supportOfSale.map(
            (element: any) => element.label
        );
        setState((prev: any) => ({
            ...prev,
            saleSupportUsed: localSaleSupportUsed,
        }));

        const isActive = consumedRes.data.some(
            (item: any) => item.id === dataSaleId
        );

        setIsModeOfSaleActiveInTemplate(isActive);
    } catch (error) {
        console.error("Error in getSaleSupportUsed:", error);
    }
};
